module.exports = __webpack_public_path__ + "static/media/stefanR.344d4482.jpg";